export enum TopicView {
  insights = "insights",
  recommendations = "recommendations",
}
